module.exports = __webpack_public_path__ + "img/pro_badge.c2edcbb.png";